var $ = require("./lib/qsa");
var pym = require("./lib/pym");
var xhr = require("./lib/xhr");
var trackEvent = require("./lib/tracking");
require("./analytics");

var { parse } = require("./csv");
var controls = $.one(".controls");
var loading = $.one(".loading-message");
var zipInput = $.one("input.zip");
var searchButton = $.one(".controls button");
var thead = $.one("table.fema thead tr");
var tbody = $.one("table.fema tbody");
var error = $.one(".error");

var downloadLink = $.one("a.download");
downloadLink.addEventListener("click", () => trackEvent("csv-download"));

var startLoad = Date.now();
var searches = 0;

xhr("./assets/fema.csv", function(err, raw) {

  var data = parse(raw);
  var header = data.shift();
  data = data.map(function(row) {
    var out = {};
    header.forEach((k, i) => out[k] = row[i]);
    if (out.Zip.length < 5) out.Zip = "0" + out.Zip;
    return out;
  });

  var columns = [
    "Fiscal Year",
    "Disaster Description",
    "Owner",
    "Address",
    "Structure",
    "Residence",
    "Status",
    "Price Paid"
  ];

  loading.setAttribute("hidden", "");
  controls.removeAttribute("hidden");

  var endLoad = Date.now();
  var elapsed = endLoad - startLoad;
  console.log(`Data loaded: ${elapsed}ms`);

  var search = function() {

    thead.innerHTML = "";
    tbody.innerHTML = "";
    error.innerHTML = "";

    var zip = zipInput.value;
    if (zip == "idkfa") zip = "66749";

    if (zip.length < 5) {
      error.innerHTML = "Invalid ZIP code";
      return;
    }

    trackEvent("search", "zip", zip);
    trackEvent("search", "count", ++searches);

    tbody.innerHTML = "Loading...";

    setTimeout(function() {

      thead.innerHTML = columns.map(c => `<th>${c}</th>`).join("");
      tbody.innerHTML = "";
      tbody.classList.remove("error");
      var found = 0;

      data.forEach(function(row) {
        if (row.Zip != zip) return;
        found++;
        var tr = document.createElement("tr");
        tr.setAttribute("role", "row");

        columns.forEach(function(p) {
          var td = document.createElement("td");
          var html = `<span class="mobile-only label" aria-hidden="true">${p}</span>`;
          if (p == "Address") {
            html += `
  ${row.Address}<br>
  ${row.City}, ${row.State} ${row.Zip}
            `;
          } else {
            var value = row[p];
            if (p == "Price Paid" && value) value = "$" + value;
            html += value || "&mdash;";
          }
          td.innerHTML = html;
          td.setAttribute("role", "cell");
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      })

      if (!found) {
        error.innerHTML = "0 results found";
        thead.innerHTML = "";
        tbody.innerHTML = "";
      }
      trackEvent("results", found ? "exist" : "none", zip);
    });
  };

  searchButton.addEventListener("click", search);
  zipInput.addEventListener("keyup", function(e) {
    if (e.keyCode == 13) search();
  })

  // example links in the control panel
  var searchSampleZip = function(e) {
    zipInput.value = e.target.dataset.zip;
    search();
  }

  var sampleZips = $("[data-zip]");
  sampleZips.forEach(z => z.addEventListener("click", searchSampleZip));

  // zipInput.value = '77013';
  // zipInput.value = '20002';
  // searchButton.click();
});
